module.exports = __webpack_public_path__ + "3682bb3b8e14af4225feb5584ff0cb65.png";